import { Company } from "../../modules/portal/companies/company.type";
import { Partner } from "../../modules/portal/partners/partner.type";
import { ViewAs } from "../../shared/components/view-as/view-as";
import { LocalStorageKeys } from "./local-storage";

function convertLocalStorageViewAsKeyToObject(): Pick<ViewAs, "company" | "partner"> | null {
  const localStorageViewAs = localStorage.getItem(LocalStorageKeys.viewAs);
  let obj = null;
  try {
    obj = JSON.parse(localStorageViewAs) as Pick<ViewAs, "company" | "partner">;
  } catch (err) {
    console.error("Unable to parse JSON to object");
  }
  return obj;
}

export function isViewAsCompany(): boolean {
  const obj = convertLocalStorageViewAsKeyToObject();
  return !!obj?.company;
}

export function isViewAsPartner(): boolean {
  const obj = convertLocalStorageViewAsKeyToObject();
  return !!obj?.partner;
}

export function getViewAsValue(key: "partner" | "company"): Partner | Company {
  const obj = convertLocalStorageViewAsKeyToObject();
  return obj?.[key];
}
